import React from "react";
import "./Frame148.css";

function Frame148(props) {
  const { className } = props;

  return (
    <div className={`frame-148 ${className || ""}`}>
      <div className="fa-qs poppins-medium-tundora-20px">FAQ’s</div>
    </div>
  );
}

export default Frame148;
